import axios from "@/libs/api.request";
export function getCertList(params) {
    return axios.request({
        url: "Certificate/getDataAllList",
        method: "get",
        params:params,
    })
}
export function getProductCertList(params) {
    return axios.request({
        url: "Certificate/getProductCertList",
        method: "get",
        params:params,
    })
}
// 添加/修改系列信息
export function addProductCert(params) {
    return axios.request({
        url: "Certificate/CreateUpdate",
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        data:params ,
    })
}

export function getTreeList(params) {
    return axios.request({
        url: "Certificate/getCertTreeNum",
        method: "get",
        params:params,
    })
}

export function getCertUnionProductList(params) {
    return axios.request({
        url: "Certificate/getCertUnionProductList",
        method: "get",
        params:params,
    })
}
export function getCertRight(params) {
    return axios.request({
        url: "Certificate/getCertListMain",
        method: "get",
        params:params,
    })
}
export function getPartImg(params) {
    return axios.request({
        url: "Certificate/getPartPic",
        method: "get",
        params:params,
        responseType: 'blob',
    })
}

export function getCertPdf(params) {
    return axios.request({
        url: "Certificate/getCertPdf",
        method: "get",
        params:params,
    })
}

export function getPartCertPdf(params) {
    return axios.request({
        url: "Certificate/getPartCertPdf",
        method: "get",
        params:params,
    })
}